// ===== DETECTOR DE INTENÇÕES =====

import { QueryType } from "../types";
import { INTENT_KEYWORDS } from "./constants";

export const detectIntent = (input: string): string => {
  const lowerInput = input.toLowerCase();

  // Verificar alunos em risco
  if (
    lowerInput.includes("aluno") &&
    (lowerInput.includes("risco") ||
      lowerInput.includes("atenção") ||
      lowerInput.includes("dificuldade"))
  ) {
    return "alunos-risco";
  }

  // Verificar desempenho de turma
  if (
    lowerInput.includes("turma") &&
    (lowerInput.includes("desempenho") || lowerInput.includes("como está"))
  ) {
    return "desempenho-turma";
  }

  // Verificar criação de atividade
  if (
    lowerInput.includes("criar") ||
    lowerInput.includes("gerar") ||
    lowerInput.includes("atividade") ||
    lowerInput.includes("exercício")
  ) {
    return "criar-atividade";
  }

  // Verificar plano de aula
  if (
    lowerInput.includes("plano") &&
    (lowerInput.includes("aula") || lowerInput.includes("ensino"))
  ) {
    return "plano-aula";
  }

  // Verificar análise de desempenho geral
  if (
    lowerInput.includes("dashboard") ||
    lowerInput.includes("panorama") ||
    lowerInput.includes("visão geral") ||
    lowerInput.includes("análise") ||
    lowerInput.includes("desempenho geral")
  ) {
    return "analise-desempenho";
  }

  return "geral";
};

export const mapIntentToQueryType = (intent: string): QueryType => {
  const intentMap: Record<string, QueryType> = {
    "alunos-risco": "alunos_com_dificuldade",
    "desempenho-turma": "analise_desempenho",
    "criar-atividade": "criar_atividade",
    "plano-aula": "criar_plano_aula",
    "analise-desempenho": "analise_desempenho",
    geral: "geral",
  };

  return intentMap[intent] || "geral";
};
